<template>
  <div class="pagebreak">
  </div>
</template>

<script>
export default {
  name: 'pagebreak',
}
</script>



// WEBPACK FOOTER //
// BlockPagebreak.vue?88c35d5a